import CryptoJS from "crypto-js"

// AES 暗号化
const encryptAES = (plainText: string, secretKey: string, iv: string) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey)
  const ivBytes = CryptoJS.enc.Utf8.parse(iv)
  return CryptoJS.AES.encrypt(plainText, key, { iv: ivBytes }).toString()
}

// AES 復号化
const decryptAES = (cipherText: string, secretKey: string, iv: string) => {
  const key = CryptoJS.enc.Utf8.parse(secretKey)
  const ivBytes = CryptoJS.enc.Utf8.parse(iv)
  const bytes = CryptoJS.AES.decrypt(cipherText, key, { iv: ivBytes })
  return bytes.toString(CryptoJS.enc.Utf8)
}

const encryptUtil = {
  encryptAES,
  decryptAES,
}

export default encryptUtil
